// extracted by mini-css-extract-plugin
var _1 = "rNsEvd2FUrMfbCXPOZSz";
var _2 = "YCKJtL6zqXsdReAVgxbw";
var _3 = "BpngjUZXkmFrNtsp3_6w";
var _4 = "vwavNQlwFM1zT1BXADhg";
var _5 = "C2jUbiQh35LoayJXkAGA";
export { _1 as "arrows", _2 as "black", _3 as "labs-chevron-scroll", _4 as "new-arrows", _5 as "white" }
